const locale = {
	// #region Group fields
	DETAILS_GROUPS_FIELD_TITLE: 'Titolo',
	DETAILS_GROUPS_FIELD_WARNING: 'Warning',
	DETAILS_GROUPS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_GROUPS_FIELD_TAGS: 'Tag',
	DETAILS_GROUPS_FIELD_USER: 'Utente',
	// #endregion

	GROUPS_USERS_IS_MANAGER: 'Manager',
	VIEW_ITEM_BUTTON_GROUP_SET_MANAGER: 'Imposta come manager',

	DIALOG_GROUP_ADD_USER_TITLE: "Scegli l'Utente da aggiungere",
	USER_ALREADY_IN_GROUP_ERROR: "L'Utente fa già parte di questo Gruppo"
};

export default locale;
